module.exports = __webpack_public_path__ + "static/media/ain_ghazal_text_04.0b22dd1f.jpg";